import { FC } from 'react';
import { Link } from 'react-router-dom';
import { FramedIcon, FramedIconSize } from '../icon/FramedIcon';
import { QuickLinkType } from './links.types';

interface IconLinkProps {
  link: QuickLinkType;
  secondary?: boolean;
}

export const IconLink: FC<IconLinkProps> = ({ link, secondary }) => {
  const content = (
    <div className="flex gap-3 text-left items-center">
      {link.Icon && <FramedIcon size={FramedIconSize.LARGE} Icon={link.Icon} className="mt-1" secondary={secondary} />}
      <div className="flex-1">
        <div className="font-semibold text-lg leading-none text-primary-std">{link.title}</div>
        {link.subtitle && <div className="font-semibold leading-none text-secondary-std pt-2">{link.subtitle}</div>}
      </div>
    </div>
  );

  if (link.to) {
    return <Link to={link.to}>{content}</Link>;
  } else {
    return (
      <button type="button" onClick={link.onClick}>
        {content}
      </button>
    );
  }
};
